// Public API of the hr module: other modules and the app import only from here.
// Pages stay out of the main bundle; the router loads them through `pages`.
export const pages = () => import("./pages");
export { strings } from "./i18n";
export { app } from "./app";
export { empName, empOption, useTerminationLabel } from "./common";
export { KPICardsTable, KPICardDrawer, ScoreBadge, KPIValue, kpiName } from "./kpi-cards";
